// src/components/pages/JoinGame.js
import React, { useState } from "react";
import {
  Box,
  Typography,
  Button,
  TextField,
  LinearProgress,
  Stack,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import AuthService from "../../utils/AuthService";
import GameServer from "../services/GameServer";

function JoinGame() {
  const [playerGameCode, setPlayerGameCode] = useState("");
  const [joined, setJoined] = useState(false);
  const [startGame, setStartGame] = useState(false);
  const [gameInfo, setGameInfo] = useState(null);
  const [invalidCode, setInvalidCode] = useState(false);
  const [missingCode, setMissingCode] = useState(false);
  const navigate = useNavigate();

  if (AuthService.isFaculty()) return null;

  const handleJoin = (e) => {
    e.preventDefault();
    if (!playerGameCode) {
      setMissingCode(true);
      return;
    }

    setMissingCode(false);
    const trimmedCode = playerGameCode.trim();

    GameServer.notify(
      trimmedCode,
      "joingame",
      { joined: "game..." },
      {
        joined: (msg) => {
          console.log("🟢 Joined message received:", msg);
          setJoined(true);
          setInvalidCode(false);
        },
        gameon: (msg) => {
          console.log("🎬 Game started:", msg);
          const info = {
            gameCode: msg.game,
            courseId: msg.course_id,
            moduleId: msg.module_id,
            chapterId: msg.chapter_id,
            lessonId: msg.lesson_id,
          };
          setGameInfo(info);
          setStartGame(true);
        },
      }
    );
  };

  if (startGame && gameInfo) {
    const url = `/Game/${gameInfo.gameCode}/course/${gameInfo.courseId}/module/${gameInfo.moduleId}/chapter/${gameInfo.chapterId}/content/${gameInfo.lessonId}`;
    navigate(url);
  }

  if (joined) {
    return (
      <Box
        sx={{
          mt: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <LinearProgress sx={{ width: "40%", mb: 2 }} />
        <Typography
          variant="h4"
          sx={{
            color: "#134950ff", // a bright cyan / teal accent
            textAlign: "center",
            letterSpacing: "1px",
            textShadow: "2px 2px 4px rgba(0,0,0,0.3)",
            mt: 2,
          }}
        >
          Wait for instructor to start the game...
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        mt: 8,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      {/* 🔹 Top-right buttons */}
      <Box
        sx={{
          position: "absolute",
          top: 16,
          right: 16,
          display: "flex",
          gap: 1,
        }}
      >
        <Button
          color="primary"
          onClick={() => navigate("/coursepage")}
          sx={{
            color: "primary.main",
            textDecoration: "underline",
            textDecorationColor: "#424242",
          }}
        >
          My Courses
        </Button>
      </Box>

      {/* 🔹 Main form */}
      <form
        onSubmit={handleJoin}
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "16px",
          alignItems: "center",
        }}
      >
        <TextField
          label="ENTER GAME PIN"
          variant="outlined"
          value={playerGameCode}
          onChange={(e) => setPlayerGameCode(e.target.value)}
          inputProps={{
            maxLength: 8,
            style: {
              textTransform: "uppercase",
              textAlign: "center",
              fontSize: "1.5rem",
              letterSpacing: "0.2em",
            },
          }}
          sx={{ width: 220 }}
        />
        <Button
          type="submit"
          variant="contained"
          color="primary"
          sx={{ borderRadius: 2, px: 4 }}
        >
          JOIN GAME
        </Button>

        {invalidCode && (
          <Typography color="error">Invalid Game Code</Typography>
        )}
        {missingCode && (
          <Typography color="warning.main">
            Please enter a game code to proceed.
          </Typography>
        )}
      </form>
    </Box>
  );
}

export default JoinGame;
